export const WeightingEnum = Object.freeze({
    fastest: 1,
    shortest: 0,
    balance: 2
})